(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pf-barefoot-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-compare')) {
    customElements.define(
      'pf-compare',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[data-pfc-tab]')];
          this.mobile = window.matchMedia('(max-width: 749.98px)');
          this.timer = null;
          this.stopped = false;
          this.visible = false;
          this.tabs.forEach((btn) => btn.addEventListener('click', () => {
            this.stopped = true;
            this.stop();
            this.setMode(btn.dataset.pfcTab);
          }));

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
          const enabled = () => this.dataset.autoplay === 'true' && !reduce.matches;
          this.update = () => {
            if (enabled() && this.mobile.matches && this.visible && !this.stopped && !document.hidden) this.start();
            else this.stop();
          };
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries.some((e) => e.isIntersecting);
            this.update();
          }, { threshold: 0.4 });
          this.io.observe(this);
          this.mobile.addEventListener('change', this.update);
          document.addEventListener('visibilitychange', this.update);
        }

        disconnectedCallback() {
          this.stop();
          this.io?.disconnect();
          this.mobile?.removeEventListener('change', this.update);
          document.removeEventListener('visibilitychange', this.update);
        }

        setMode(mode) {
          this.dataset.mode = mode;
          this.tabs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.pfcTab === mode)));
        }

        start() {
          if (this.timer) return;
          this.dataset.running = 'true';
          const ms = Math.max(2000, Number(this.dataset.interval) || 5000);
          this.timer = setInterval(() => {
            this.setMode(this.dataset.mode === 'before' ? 'after' : 'before');
          }, ms);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
          this.dataset.running = 'false';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
